import { EfsMelcoModelsDesign } from "melco-shared-logic";
import { StitchCanvas } from "@melco/renderer-react-component";
import styled from "styled-components";
import { useDesignElementConfiguration } from "../../hooks/libraries/designs/useDesignElementConfiguration";
import { useDesignRenderer } from "../../hooks/renderer/useDesignRenderer";

const CanvasWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 800px;
`;

type RenderedDesignProps = {
  design: EfsMelcoModelsDesign;
};

export const RenderedDesign: React.FC<RenderedDesignProps> = ({ design }) => {
  const elementConfiguration = useDesignElementConfiguration(design.rfm_url!);

  const { canvasId, initCallback, rendererState, isLoading } =
    useDesignRenderer(design, elementConfiguration);

  const { scene, viewPort, renderOptions, animationParams } = rendererState;

  return (
    <CanvasWrapper>
      {isLoading && "Loading..."}

      <StitchCanvas
        canvasId={canvasId}
        initCallback={initCallback}
        scene={scene}
        viewPort={viewPort}
        renderOptions={renderOptions}
        animationParams={animationParams}
      />
    </CanvasWrapper>
  );
};
